import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FaUniversity, FaUsers } from 'react-icons/fa';

import PageHeader from '../../Components/PageHeader/PageHeader';
import RResearchProject from '../../Components/RResearchProject/RResearchProject';
import RPublication from '../../Components/RPublication/RPublication';

const Research = () => {

    const location = useLocation();

    useEffect(() => {
        const pathname = location.pathname;
        let trimmedPathname = pathname;
        if (pathname.endsWith("/")) {
            trimmedPathname = pathname.slice(0, pathname.length - 1); // Remove trailing slash if present
        }
        const segments = trimmedPathname.split("/");
        setActiveId(segments[segments.length - 1])
    }, [location])

    const [activeId, setActiveId] = useState();

    const menuItems = [
        {
            id: 1,
            title: 'Research',
            path: 'researchProject',
            icon: <FaUniversity />,
            content: <RResearchProject />
        },
        {
            id: 2,
            title: 'Publication',
            path: 'publication',
            icon: <FaUsers />,
            content: <RPublication />
        }
    ];

    return (
        <>
            <PageHeader
                title="Research"
                breadcrumbs={[
                    { label: 'Home', href: '/' },
                    // { label: 'About', href: '/about' },
                    { label: 'Research' }
                ]}
            />

            <div className="container py-5">

                <div className='row'>
                    {/* Left Menu */}
                    <div className="col-md-3">
                        <div className="border bg-white p-4 shadow-sm rounded h-100">
                            <div className="list-group">
                                <h5 className="fw-bold text-primary mb-4 border-start border-4 ps-2 border-primary">
                                    Research
                                </h5>
                                {menuItems.map((item) => (
                                    <button
                                        key={item.id}
                                        className={`list-group-item list-group-item-action d-flex mb-2 justify-content-start ${activeId === item.path ? 'active-menu' : ''}`}
                                        onClick={() => setActiveId(item.path)}
                                    >
                                        <span className="me-2 icon-text">{item.icon}</span> {item.title}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Right Content */}
                    <div className="col-md-9">
                        <div className="border bg-white p-4 shadow-sm rounded h-100">
                            <h5 className="fw-bold text-primary mb-4 border-start border-4 ps-2 border-primary">
                                {menuItems.find((item) => item.path === activeId)?.title}
                            </h5>
                            <div className="text-muted">
                                {menuItems.find((item) => item.path === activeId)?.content}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default Research;